module.exports =
  '_SCORE_CARD_BOARD':
    'OUT': "OUT"
    'IN': "IN"
    'EXTRA': "EXTRA"
    'HOLE': "Hole"
    'PAR': "Par"
    'TEE_OFF_CLUB': "Tee Off Club"
    'FAIRWAY_HIT': "Fairway Hit On Drive"
    'PAR_ON': "GIR"
    'SAND_SAVES': "Sand Saves"
    'OB': "OB"
    'WATER_HAZARD': "Water"




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/score-card/i18n/en.coffee